// extracted by mini-css-extract-plugin
module.exports = {"modal":"z5wK-0","header":"_2KLVDi","secondary":"_1zWEO3","content":"_3iZPLd","smallPrint":"VT2jxW","pinInput":"_35Tp_m","actionButton":"_23jgMH"};